import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Spinner } from "@krea/shared/design-system/Spinner";
import { useAuthStore } from "@krea/shared/features/auth/authStore";

import { useCurrentLenderCompanyStore } from "../lender-companies/current-lender-company-store";
import { useGetMyLenderCompaniesQuery } from "../lender-companies/hooks/use-get-my-lender-companies.query";
import { useGetMeQuery } from "../users/hooks/use-get-me.query";

export const RootPage = () => {
  const { data: me, isPending } = useGetMeQuery();
  const accessToken = useAuthStore((state) => state.accessToken);
  const companiesQuery = useGetMyLenderCompaniesQuery(
    {
      limit: 2,
      offset: 0,
    },
    {
      enabled: !!me,
    },
  );
  const currentLenderCompanyId = useCurrentLenderCompanyStore(
    (state) => state.lenderCompanyId,
  );
  const setCurrentLenderCompany = useCurrentLenderCompanyStore(
    (state) => state.setCurrentLenderCompany,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if ((!me && !isPending) || !accessToken) {
      navigate("/login");

      return;
    }

    if (me?.isAdmin) {
      navigate("/select-lender-company");

      return;
    }

    if (currentLenderCompanyId) {
      navigate(`/lender-company/${currentLenderCompanyId}`);

      return;
    }

    if (companiesQuery.data?.pages[0]?.items.length === 1) {
      const lenderCompanyId = companiesQuery.data.pages[0].items[0]?.id;
      if (lenderCompanyId) {
        setCurrentLenderCompany(lenderCompanyId);
        navigate(`/lender-company/${lenderCompanyId}`);
      } else navigate("/select-lender-company");
    }

    if (
      companiesQuery.data?.pages[0]?.items.length &&
      companiesQuery.data.pages[0].items.length > 1
    ) {
      navigate("/select-lender-company");
    }
  }, [
    companiesQuery.data,
    currentLenderCompanyId,
    navigate,
    setCurrentLenderCompany,
    isPending,
    me,
    accessToken,
  ]);

  return (
    <div className="flex h-full items-center justify-center">
      <Spinner className="size-10" />
    </div>
  );
};
